import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "colorbar-labels" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "colorbar-container-horizontal"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "start", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.startValue), 1)
        ], true)
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ], true)
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "end", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.endValue), 1)
        ], true)
      ])
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({'--background-color': _ctx.backgroundColor}),
      class: "colorbar"
    }, null, 4)
  ], 8, _hoisted_1))
}